module.exports = __webpack_public_path__ + "img/vip_dialog_top_bg.e489b641.png";